import {
  BottomSheetComponent,
  Modal,
  NavigationConfig,
  registerBottomSheets,
  registerNavigationHandlers,
} from '@bonanza-social/navigation';

import {
  SOFAttestationScreen,
  AccountMFAScreen,
  AccountBiometricLoginScreen,
  GamingHistoryScreen,
  CoinsGamingTransactionsScreen,
  NotificationsScreen,
  TransactionHistoryScreen,
  MyProfileScreen,
} from '../screens';
import {
  ScreenNameInfoBottomSheet,
  SOFBottomSheet,
  CloseAccount,
} from '../bottomSheets';
import {
  ChangePasswordScreen,
  ContactUsScreen,
} from '@bonanza-social/auth/screens';


export const NAVIGATION_CONFIG: NavigationConfig<AppNavigatorParamsList> = {
  FULL_SCREENS: [
    {
      name: 'SOFAttestation',
      options: { headerShown: true },
      component: SOFAttestationScreen,
    },
    {
      name: 'TransactionHistory',
      options: {},
      component: TransactionHistoryScreen,
    },
    {
      name: 'MyProfile',
      options: {},
      component: MyProfileScreen,
    },
    {
      name: 'TwoFactorAuthentication',
      options: { headerShown: true },
      component: AccountMFAScreen,
    },
    {
      name: 'BiometricLogin',
      options: {},
      component: AccountBiometricLoginScreen,
    },
    {
      name: 'ChangePasswordScreen',
      options: { headerShown: true },
      component: ChangePasswordScreen,
    },
    {
      name: 'GamingHistory',
      options: {},
      component: GamingHistoryScreen,
    },
    {
      name: 'CoinsGamingTransactions',
      options: {},
      component: CoinsGamingTransactionsScreen,
    },
    {
      name: 'ContactUsScreen',
      options: {},
      component: ContactUsScreen,
    },
    {
      name: 'Notifications',
      options: { headerShown: true },
      component: NotificationsScreen,
    },
  ],
  FULL_SCREEN_MODALS: [],
  FULL_SCREEN_MODALS_TRANSPARENT: [],
};

const bottomSheets = {
  SOF: SOFBottomSheet,
  ScreenNameInfo: ScreenNameInfoBottomSheet,
  CloseAccount,
};

registerBottomSheets('account', bottomSheets);

declare global {
  interface RegisteredBottomSheets {
    account: Record<keyof typeof bottomSheets, BottomSheetComponent>;
  }
}

registerNavigationHandlers<
  AppNavigatorParamsList,
  | 'MyProfile'
  | 'TransactionHistory'
  | 'GamingHistory'
  | 'CoinsGamingTransactions'
  | 'SessionHistory'
  | 'TwoFactorAuthentication'
  | 'Notifications'
  | 'ReferrerPromoScreen'
  | 'LossLimit'
  | 'PlaytimeLimit'
  | 'SOFAttestation'
  | 'ContactUsScreen'
>({
  MyProfile(navigate) {
    navigate('/account/details');
  },
  TransactionHistory(navigate) {
    navigate('/account/payment-history');
  },
  GamingHistory(navigate) {
    navigate('/account/game-transactions');
  },
  CoinsGamingTransactions(navigate) {
    navigate('/account/coins-game-transactions');
  },
  SessionHistory(navigate) {
    navigate('/account/sessions');
  },
  TwoFactorAuthentication() {
    Modal.open({
      namespace: 'account',
      type: 'TwoFactorAuthentication',
    });
  },
  Notifications() {
    Modal.open({
      namespace: 'account',
      type: 'Notifications',
      style: {
        padding: 'space-400',
      },
    });
  },
  ReferrerPromoScreen(navigate, params) {
    const { path } = params ?? {};
    if (!path) {
      return;
    }
    navigate(path);
  },
  LossLimit(navigate) {
    navigate('/account/limits/loss');
  },
  PlaytimeLimit(navigate) {
    navigate('/account/limits/playtime');
  },
  SOFAttestation(navigate) {
    navigate('/account/source-of-funds');
  },
});
